import { render, staticRenderFns } from "./active-inactive-user.vue?vue&type=template&id=05b08d82"
import script from "./active-inactive-user.vue?vue&type=script&lang=js"
export * from "./active-inactive-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports